module.exports = __webpack_public_path__ + "static/media/squareIndia.7c666b81.svg";